export default __webpack_public_path__ + "cc68c270c18e5af15354e9d55b3808f6.svg";